
<template>
  <v-dialog
    v-model="innerVal"
    max-width="400px"
    persistent
  >
    <v-card
      class="px-5 py-10"
      rounded="lg"
    >
      <v-card-text>
        <slot>
          <h2 class="text-center">
            {{ message }}
          </h2>
        </slot>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <!-- Confirm Btn -->
        <v-btn
          rounded
          depressed
          color="primary"
          width="100px"
          class="mx-3 text-none"
          @click="confirmAction"
        >
          {{ confirm }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'BaseAlertDialog',

    props: {
      value: { type:Boolean, default:false },
      message: { type:String, default:'' },
      confirm: { type:String, default:'Close' },
    },

    data() {
      return {
        innerVal: this.value
      }
    },

    watch: {
      value(val) {
        this.innerVal = val
      },
      innerVal(val) {
        this.$emit('input', val)
      }
    },

    methods: {
      confirmAction() {
        this.innerVal = false
        this.$emit('confirm')
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>